<template>
  <div :class="{'m-container':true, 'm-padding':list.length>0}">
    <switchShop
      :returnPath="'cart'"
      v-if="storeType == 'newRetailApplet'">
    </switchShop>
    <template v-if="list.length>0">
      <van-cell class="m-cart-header" :border="false">
        <span slot="title" :style="{'color':themeColor[0]}" >{{page.total}}件商品</span>
        <span v-if="isEditing" class="m-text-small m-text-primary" @click="completeEdit">完成</span>
        <span v-else class="m-text-small m-text-primary" @click="editing()">编辑</span>
      </van-cell>
      <van-list
        class="m-order-list"
        v-model="page.loading"
        :finished="page.finished"
        finished-text="没有更多了"
        @load="nextPage">
        <div
          class="m-order-list-item"
          v-for="(item,index) in list"
          :key="index">
          <van-checkbox @change="countPrice" :disabled="item.disable&&!isEditing" v-model="item.checked" :checked-color="themeColor[0]"></van-checkbox>
          <van-card
            :price="item.realPrice.toFixed(2)"
            :desc="item.skuName"
            :title="item.goodsName"
            :thumb="item.showpic"
            :origin-price="item.oriPrice"
            :style="{'color':themeColor[0]}"
            @click-thumb="goGoodsDetail(item.goodsId)"
          >
            <div slot="num">
              <van-stepper v-if="showChange" :name="item.id" :disabled="item.disable" v-model="item.count"  @change="updateNum"/>
              <van-stepper v-if="!showChange" :name="item.id" disabled="disabled" v-model="item.count"  @change="updateNum"/>
            </div>
            <div slot="price-top" v-if="item.vipprice!=null">
              <van-tag plain  :style="{'color':themeColor[0],'border':'1px solid '+themeColor[0]+''}" >会员价 ￥{{Number(item.vipprice).toFixed(2)}} </van-tag>
            </div>
            <!--            <div slot="tags" v-if="item.discounts&&!isEditing">-->
            <!--              <van-tag plain round :color="themeColor[0]">{{item.discounts}}</van-tag>-->
            <!--            </div>-->
            <template v-if="item.designName !== '' && item.designName !== null">
              <div slot="footer" class="m-text-small" v-if="!isEditing">
                <div>￥{{Number(item.designPrice).toFixed(2)}}</div>
                <div class="m-text-primary">
                  <!-- <span class="m-text-secondary">类型：</span> -->
                  <span>{{item.designName}}</span>
                </div>
              </div>
            </template>
          </van-card>
        </div>
      </van-list>
      <van-cell class="m-order-footer van-hairline--top">
          <van-checkbox v-model="checkedAll" @click="chooseAll" :checked-color="themeColor[0]">全选</van-checkbox>
          <div class="combined">
          <span v-if="!isEditing" class="m-text-middle">合计：￥<span>{{sumPrice}}</span> </span>
            <span>会员价：￥{{sumVipPrice}}</span>
        </div>
        <div slot="right-icon">
          <van-button v-if="isEditing" :style="{'color':'#606266', 'border':'1px solid #606266'}" size="small" plain @click="showDeleteDialog=true">删 除</van-button>
          <van-button v-else :style="{'background-image':'linear-gradient(to right, '+themeColor[1]+','+ themeColor[0]+')'}" size="small" @click="countOrder">去结算</van-button>
        </div>
      </van-cell>
      <van-dialog
        v-model="showDeleteDialog"
        confirm-button-text="确定"
        :confirm-button-color="themeColor[0]"
        show-cancel-button
        @confirm="deleteShopCart"
        message="确定删除选中的商品吗？"
      ></van-dialog>
    </template>
    <template v-else>
      <div class="m-nodata" v-if="showEmpty">
        <!-- <img src="~@/../static/imgs/no-cart.png"/> -->
        <img src="../../templates/imgs/cartNocon.svg">
        <p>购物车空空如也，快去逛逛吧</p>
        <van-button  type="default" :style="{'background-image': 'linear-gradient(to right, '+themeColor[1]+', '+themeColor[0]+')'}" size="small" @click="goGoodsList">去购物</van-button>
      </div>
      <!-- <div class="m-list-title" :style="{'color':themeColor[0]}">
        <div class="m-deco">
          <div :style="'background-image: linear-gradient(to right, #f5f7fa, '+themeColor[0]+')'"></div>
          <div :style="'background-image: linear-gradient(to right, #f5f7fa, '+themeColor[1]+')'"></div>
        </div>
       <span>热卖推荐</span>
        <div class="m-deco">
          <div :style="'background-image: linear-gradient(to left, #f5f7fa, '+themeColor[0]+')'"></div>
          <div :style="'background-image: linear-gradient(to left, #f5f7fa, '+themeColor[1]+')'"></div>
        </div>
      </div> -->
      <div class="m-list">
        <div class="m-list-item" v-for="(item,index) in goodsList" :key="index">
          <router-link :to="item.url">
            <div class="m-list-img">
              <van-image :src="item.image" fit="cover"/>
            </div>
            <div class="m-list-info">
              <div class="m-list-name van-ellipsis">{{item.title}}</div>
              <div class="m-list-price">
                <span :style="{'color':themeColor[0]}">￥{{item.price}}</span>
                <del>￥{{item.initialPrice}}</del>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <van-loading size="24px" vertical v-if="!showEmpty" style="top: 18.75rem;">加载中...</van-loading>
<!--      <div class="m-nomore">没有更多了</div>-->
    </template>
  </div>
</template>

<script>

    import {mapGetters} from 'vuex';
    import {Cell, Card, Stepper, Checkbox, Button, Dialog, Image, Tag, List, Toast ,Field,Loading} from 'vant';
    import {doJsonPost, doFormPost, doJsonGet, doFormGet} from '@/utils/request';
    //2021-07新增首页头部切换店铺
    import  switchShop  from '@/templates/components/switchShop.vue';

    export default {
        name: 'cart',
        components: {
            [Cell.name]: Cell,
            [Card.name]: Card,
            [Stepper.name]: Stepper,
            [Checkbox.name]: Checkbox,
            [Button.name]: Button,
            [Dialog.Component.name]: Dialog.Component,
            [Image.name]: Image,
            [Tag.name]: Tag,
            [List.name]: List,
            [Toast.name]: Toast,
            [Field.name]: Field,
            switchShop
        },
        computed: {
            ...mapGetters([
                'theme',
                'storeType'
            ]),
            themeColor() {
                return this.theme.colors
            },
            store() {
                return this.storeType
            }
        },
        data() {
            return {
                checkedAll: false,
                isEditing: false,
                showDeleteDialog: false,
                showChange:false,
                list: [],
                shopId:'',
                showEmpty:false,
                goodsList: [],
                isHaidilao:this.$store.state.app.isHaidilao,
                page: {
                    loading: true,
                    finished: false,
                    pageNum: 1,
                    pageSize: 40,
                    total: 0
                },
                sumPrice: 0,
                sumVipPrice:0,
                allCartPrice: 0,
                allCartVipPrice: 0,
                allCartId: []
            }
        },
        methods: {
            completeEdit() {
                this.isEditing=false;
                let flag = false;
                this.list.forEach(item =>{
                    if (item.disable&&item.checked) {
                        item.checked = false;
                        flag = true;
                    }
                })
                this.countPrice();

            },
            queryShopCartList() {
                var that = this;
                doFormPost('/shopCart/queryCartList', this.page, rs => {
                    if (rs.result === 'success') {
                        that.page.total = rs.userData.total;
                        if (that.page.total === 0) {
                            that.page.finished = true;
                            that.showEmpty =true;
                        } else {
                            var totalPageNum = parseInt(that.page.total / that.page.pageSize);
                            if (that.page.total / that.page.pageSize > totalPageNum) {
                                totalPageNum += 1;
                            }
                            if (that.page.pageNum >= totalPageNum) {
                                that.page.finished = true;
                            }
                            if (rs.userData.basketList.length === 0) {
                                that.page.finished = true;
                            } else {
                                if (that.list.length > 0) {

                                    rs.userData.basketList.forEach(item => {
                                        that.list.push(item);
                                    })
                                } else {
                                    that.list = rs.userData.basketList;
                                }
                            }
                        }
                        that.page.loading = false;
                        if (that.checkedAll) {
                          that.chooseAll(true);
                        }else{
                          that.chooseCheck();
                        }
                    } else {
                        Toast(rs.message);
                         that.showEmpty = true;
                    }
                })
            },
            nextPage() {
                this.page.pageNum = this.page.pageNum + 1;
                this.queryShopCartList();
            },
            countPrice() {
                var cartId = '';
                this.list.forEach(item => {
                    if (item.checked) {
                       cartId += item.id + ',';
                       sessionStorage.setItem("shop_cart"+item.id,item.id);
                    }else{
                      sessionStorage.removeItem("shop_cart"+item.id)
                      this.checkedAll = false
                    }
                })
                //全部选中购物城数据后，全选按钮状态不改变问题修改
                if(cartId!=''){
                  var cartArr = cartId.split(",");
                  var cmt = cartArr.length;
                  if((cmt-1)==this.list.length){
                    this.checkedAll =true;
                  }
                }
                var that = this;
                if (cartId === '') {
                    that.sumPrice = 0;
                    that.sumVipPrice = 0;
                    return;
                }
                // 全选按钮优化处理
                var allCart = this.checkedAll //是否全选
                /* if(allCart){
                  if(this.allCartPrice){
                    this.sumPrice = this.allCartPrice;
                    this.sumVipPrice = this.allCartVipPrice;
                    return
                  }
                  // cartId = null
                } */
                doFormPost('/shopCart/computeGoodsSumPrice', {cartId: cartId}, rs => {
                    if (rs.result === 'success') {
                        that.sumPrice = Number(rs.userData.sumPrice);
                        that.sumVipPrice = Number(rs.userData.sumVipPrice);
                        if(allCart){
                          that.allCartPrice = that.sumPrice
                          that.allCartVipPrice = that.sumVipPrice
                          that.allCartId = rs.userData.cartId
                        }
                    } else {
                        Toast(rs.message);
                        that.sumPrice = 0;
                        that.sumVipPrice = 0;
                    }
                })
            },
            updateNum(value, detail) {
                let that = this;
                if(''==value){}else{
                  doFormPost('/shopCart/updateCartGoodsNum', {cartId: detail.name, num: value}, rs => {
                    if (rs.result === 'success') {
                        that.list.forEach(item => {
                            if (item.id === rs.userData.id) {
                                item = rs.userData;
                            }
                        })
                    } else {
                        Toast(rs.message);
                        that.page.pageNum = 1;
                        that.page.finished = false;
                        that.page.loading = true;
                        that.list = [];
                        that.queryShopCartList();
                    }
                    that.countPrice();
                  })
                }
            },
            deleteShopCart() {
                var cartCodes = [];
                var codes = '';
                if(this.checkedAll){
                  cartCodes = this.allCartId
                  codes = cartCodes.join()
                }else{
                  this.list.forEach(item => {
                      if (item.checked) {
                          cartCodes.push(item.id);
                          codes += item.id + ',';
                      }
                  })
                }
                if (cartCodes.length === 0) {
                    Toast('请选择要删除的商品');
                    return;
                }
                var that = this;
                doFormPost('/shopCart/delCartGoods', {cartId: codes}, rs => {
                    if (rs.result === 'success') {
                        that.page.pageNum = 1;
                        that.list  =[];
                        that.allCartPrice = 0;
                        that.allCartVipPrice = 0;
                        that.queryShopCartList();
                        // var list = [];
                        // that.list.forEach(item => {
                        //     if (!cartCodes.includes(item.id)) {
                        //         list.push(item);
                        //     }
                        // })
                        // that.list = list;
                        // if (list.length === 0) {
                        //     that.page.pageNum = 1;
                        // }
                    } else {
                        Toast(rs.message);
                    }
                })
            },
            chooseCheck(){
              this.list.forEach(item => {
                let cid = sessionStorage.getItem("shop_cart"+item.id);
                if(item.id == cid){
                  item.checked = true;
                }else{
                  item.checked = false
                }
              })
              this.countPrice();
            },
            chooseAll(checked) {
                this.list.forEach(item => {
                    item.checked = this.checkedAll;
                })
                this.countPrice();
            },
            goGoodsDetail(code) {
                this.$router.push({
                    name: 'detail',
                    params: {
                        goodsId: code
                    }
                })
            },
            goGoodsList() {
                let name = 'category'
                if (this.store === 'rzGroupBuy') {
                    name = 'index';
                }
                this.$router.push({
                    name: name
                })
            },
            countOrder() {
                this.sendRecord('click_to_settle',{page:'结算'})
                var cartCodes = [];
                var total=0;
                if(this.checkedAll){
                  cartCodes = this.allCartId
                }else{
                  this.list.forEach(item => {
                      if (item.checked) {
                          cartCodes.push(item.id);
                      }
                  })
                }
                var codes = cartCodes.join();
                if (cartCodes.length === 0) {
                    Toast('请选择要结算的商品');
                    return;
                }
                if(this.$store.state.app.brandConfig.isDtbx){
                  // if (cartCodes.length < 5) {
                  //     Toast('该产品5件起卖');
                  //     return;
                  // }
                  // this.list.forEach(item => {
                  //     if (item.checked) {
                  //         total += parseInt(item.count)
                  //     }
                  // })
                  // var maxNum =  this.$store.state.app.maxNum;
                  // var areadyNum =  this.$store.state.app.areadyNum;
                  // if(!maxNum){
                  //   maxNum = localStorage.getItem("maxNum")
                  //   areadyNum = localStorage.getItem("areadyNum")
                  // }
                  // var num='';
                  // if(areadyNum!=''){//已经做了
                  //   var num =parseInt(maxNum) -parseInt(areadyNum);

                  // }else{
                  //   num = maxNum;
                  // }
                  // if(total != parseInt(num)){
                  //   var txet = "您的下单数量为"+num+",请修改";
                  //   Toast(txet);
                  //   return;
                  // }
                }
                this.$router.push({
                    name: 'orderConfirm',
                    params: {
                        basketList: codes
                    }
                })
            },
            editing(){
              this.isEditing=true
              this.sendRecord('click_edit',{page:'编辑购物车'})
            }
        },
        created() {
            this.shopId =  this.$store.state.app.shopId;
            // 大童保险/海底捞
            if(this.$store.state.app.brandConfig.isDtbx||this.isHaidilao){
              this.showChange = false;
            }else{
              this.showChange = true;
            }

            this.queryShopCartList();
            this.sendPV({page:'购物车'})
        }
    }
</script>

<style scoped>
.m-container {
  padding: 0 0 50px;
}
.m-container.m-padding {
  padding: 45px 0 100px;
}
.m-cart-header {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 2;
  background: #F5F7FA;
  padding-bottom: 0;
}
.m-order-list{
  background: transparent;
  margin: 0;
}
.m-order-list-item {
  position: relative;
  padding-left: 28px;
  background: #fff;
  margin: 0 12px 10px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 0 8px #DCDFE6;
  line-height: 1.5;
}
.m-order-list-item a{
  border-radius: 8px;
  overflow: hidden;
}
.m-order-list-item .van-stepper::after{
border: none;
}
.m-order-list-item /deep/ button{
  border:1px solid #C0C4CC;
  border-radius: 50%;
}
.m-order-list-item /deep/ input{
  background: transparent !important;
}
.m-order-list-item .van-card__footer>div{
  padding: 0;
  border-radius: 20px;
  color: #EF4056 !important;
  margin: 8px 0 0 110px;
  justify-content: flex-start;
  text-indent: 8px;
  background-image: linear-gradient(to right ,#ffdfc2, #ffffff);
  opacity: .6;
}
.m-order-list-item .van-checkbox {
  position: absolute;
  left: 12px;
  top: 50%;
  margin-top: -10px;
  z-index: 1;
}
.m-order-list-item .van-card__footer{
  min-height: 16px;
}
.m-order-list-item .m-text-primary{
  color:#EF4056;
}
.m-order-list-item /deep/ .van-tag--plain{
  border-radius: 4px;
  overflow: hidden;
  font-size: 12px;
  line-height: 1.5;
  margin-bottom: 4px;
}
.m-order-list-item .van-tag--plain::before{
  border: none;
}
.m-order-footer {
  bottom: 56px;
  padding: 2px 12px 6px !important;
  box-shadow: 0 0 12px #DCDFE6;
}
.m-order-footer /deep/ button{
  border-radius: 8px;
  padding: 0 16px;
  color: #ffffff;
  border: none;
}
.m-nodata button{
  border: none;
  order: none;
  color: #fff;
  border-radius: 8px;
  padding: 0 16px;
}
.m-nodata img{
  height: 160px;
}
.m-list-title {
  font-size: 16px;
  text-align: center;
  margin: 12px;
}
.m-list-title .m-deco {
  display: inline-block;
  margin: 0 12px;
}
.m-list-title .m-deco > div {
  width: 37px;
  height: 5px;
  border-radius: 3px;
}
.m-list-title .m-deco > div:last-child {
  width: 24px;
  height: 3px;
  margin-top: 3px;
  margin-left: 20px;
}
.m-list-title span + .m-deco > div:last-child {
  margin-left: 0;
}
.m-list-title span + .m-deco > div:first-child {
  margin-left: 8px;
}
.m-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 12px;
}
.m-list-item {
  width: 49%;
  margin-bottom: 12px;
  background: #fff;
  overflow: hidden;
  position: relative;
  border-radius: 4px;
}

.m-list-item a {
  display: block;
  color: #434a54;
}

.m-list-img {
  padding: 50% 0;
  position: relative;
}


.m-list-img .van-image {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.m-list-info {
  padding: 8px;
}

.m-list-name {
  font-size: 13px;
}

.m-list-price {
  font-size: 15px;
}

.m-list-price del {
  font-size: 10px;
  color: #aab2bd;
}
.m-order-list /deep/ .van-list__finished-text{
  margin-bottom: 24px;
}
.m-order-footer .van-cell__value--alone{
  display: flex;
}
.m-order-footer .van-checkbox{
  flex: 1;
}
.m-order-footer .combined{
  flex: 3;
  text-align: left;
}
.m-order-footer .combined>span{
  display: block;
  display: flex;
  line-height: 1.5;
}
.m-order-footer .combined>span span{
  color: #EF4056;
  font-weight: 500;
}
.m-order-footer .combined>span:first-child{
  font-size: 15px;
}
.m-order-footer .combined>span:last-child{
  font-size: 12px;
  color:#909399;
}
</style>



// WEBPACK FOOTER //
// src/views/order/cart.vue